<template>
  <div v-if="chips.length" class="applied-chips">
    <span class="applied-chips-heading">Applied Filters:</span>
    <span
      v-for="chip in chips"
      :key="chip.key"
      class="applied-filter-chip"
      :title="chip.fullValue || chip.value"
    >
      <span class="chip-label">{{ chip.label }}:</span>
      <span class="chip-value">{{ chip.value }}</span>
      <button
        type="button"
        class="applied-filter-remove"
        :aria-label="'Remove ' + chip.label + ' filter'"
        @click="$emit('remove', chip.key)"
      >
        <img src="@/assets/cancel.svg" alt="" />
      </button>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DashboardFilterChips",
  props: {
    chips: { type: Array, default: () => [] },
  },
  emits: ["remove"],
});
</script>
